import React from 'react';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import REQUIRED_FIELDS from '../../offers/REQUIRED_FIELDS';
import ChartLoader from '../../states/_charts/ChartLoader';
import LegendChart from '../../states/_charts/LegendChart';
import { creator_state_$ilike } from '../../../utils/query-helpers';

export default function OfferActivityYear(props) {
  const { state, network, schoolStart, schoolEnd, subtitle, activities } = props;

  const allOffers = useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          // networkId: network?.id,
          ...creator_state_$ilike(state),
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const requests = _.sortBy(activities.data, at => at.data.name).map(function(activity) {
    return {
      label: activity.data.name,
      offers: useConnect('offer.find', {
        where: {
          eager: {
            $where: {
              $and: REQUIRED_FIELDS.$and,
              activityId: activity.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              },
              // networkId: network?.id,
              ...creator_state_$ilike(state),
            }
          }
        },
        pagination: {
          pageSize: 1
        }
      })
    };
  });

  const loading = _.reduce(requests, function(result, request) {
    return result || request.offers.state === PayloadStates.FETCHING;
  }, false)

  if (loading || allOffers.state === PayloadStates.FETCHING) {
    return (
      <ChartLoader
        title="Offers by Activity"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const sortedRequests = _.sortBy(requests, r => -r.offers.meta.totalCount);

  const series = sortedRequests.map(r => r.offers.meta.totalCount);
  const labels = sortedRequests.map(r => r.label);

  return (
    <LegendChart
      title="Offers by Activity"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
    />
  );
}
